import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';

gsap.registerPlugin(ScrollTrigger);

const numbersEl = document.querySelectorAll('.numbers');

const mm = gsap.matchMedia();

if (!localStorage.getItem('zoom-mode-level')) {
  mm.add('(min-width: 64em)', () => {
    numbersEl &&
      numbersEl.forEach(number => {
        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: number,
            start: `center bottom-=100px`,
            end: 'center top',
            scrub: true,
          },
        });

        tl.addLabel('start')
          .from(number, { translateX: 0, ease: 'power1.in' })
          .addLabel('move')
          .to(number, { translateX: '-10%', ease: 'power1.in' })
          .addLabel('end');
      });
  });
}
